import { observer } from 'mobx-react'
import React from 'react'
import { Button, Loader } from 'ui-framework'
import StakingFormVM from '../StakingFormVM'
import SpendingAllowance from './SpendingAllowance'
import Stake from './Stake'
import Unstake from './Unstake'

const loader = (
  <div className="panel--simple padded-2 flex-center margin-bottom-2">
    <Loader quantityDots={3} sizeDots="small" />
  </div>
)

export function AddToBalance({ vm }: { vm: StakingFormVM }) {
  return (
    <React.Fragment>
      <div className="margin-top-2 margin-bottom-3">
        <div className="flex-row-center margin-bottom-2">
          <div className="btn--sticked-horizontal">
            {vm.userBalances.wallet.isWorthEnough && (
              <Button
                variant="tab-blue"
                active={!vm.unstakeSelected}
                onClick={vm.set}
                onClickEmit="name-value"
                name="unstakeSelected"
                value={false}>
                Stake
              </Button>
            )}
            {vm.userBalances.staked.isWorthEnough && (
              <Button
                variant="tab-blue"
                active={vm.unstakeSelected}
                onClick={vm.set}
                onClickEmit="name-value"
                name="unstakeSelected"
                value={true}>
                Unstake
              </Button>
            )}
          </div>
          {/* {loader} */}
        </div>

        {vm.rootStore.web3Connection.isConnected &&
          !vm.stakingStore.stakingAllowances.allowanceChecked &&
          loader}

        {vm.stakingStore.stakingAllowances.allowanceChecked && (
          <>
            {!vm.unstakeSelected && <SpendingAllowance vm={vm} />}

            {vm.stakingStore.stakingAllowances.needApprovalList.length < 4 &&
              (vm.unstakeSelected ? <Unstake vm={vm} /> : <Stake vm={vm} />)}
          </>
        )}
      </div>
    </React.Fragment>
  )
}

export default observer(AddToBalance)
